import { render, staticRenderFns } from "./HotItemLocation.vue?vue&type=template&id=384ca946&"
import script from "./HotItemLocation.vue?vue&type=script&lang=js&"
export * from "./HotItemLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports